<p-dialog [(visible)]="showDialog" [modal]="true" [draggable]="false" [resizable]="true" (onHide)="closeJobModal()" class="dispatch-modal market-modal job-modal card-spacing" style="width:40% !important;">
  <ng-template pTemplate="header">
    <div class="w-100 mx-3" style="display: flex;align-items: center;justify-content: space-between;">
        <span style="font-size: 18px;font-weight: 500;">{{jobFormTitle}}</span>
        <span style="font-size: 18px;font-weight: 500;">
          <button pButton pRipple type="button" icon="pi pi-check" iconPos="right" label="Save" class="p-button-rounded button-save cursor" 
            [ngClass]="{'setOpacity5': jobExist || discountValueErrorFlag}" (click)="!jobExist && !discountValueErrorFlag ? jobFormAction('submit') : false;"></button>
        </span>
    </div>   
  </ng-template>
  <div class="action-form"> 
    <form [formGroup]="jobForm">
      <div class="row service-form-fields job-form-fields col-12">
        <div class="service-form-row col-4">
          <div class="label">
              <label>
                  <img src="assets/images/common/job-opt-name.png" alt="Option Name" class="icons-size mr-2 new-request-icon" />
                  <span class="split-col text-col">Option Name
                    <img style="position: relative;top: 0px;left: 5px;cursor: pointer; width: 15px;" src="assets/images/common/info-gray.png" popoverClass="custom-tooltip menu-tooltip close-tooltip job-help-tooltip-icon" [ngbPopover]="infoMenu" popoverTitle="Select option name and value for automated assignments and workflows" placement="right" triggers="hover">
                    <ng-template #infoMenu></ng-template>
                  </span>
              </label>
          </div>
          <div class="field">
              <p-dropdown [placeholder]="'Select'" [options]="jobOptionNameLists" formControlName="optionName" 
                class="input-with-icon-inside-select" optionLabel="name" optionValue="id"
                (onChange)="accessLevel.create ? onChangeNameOption($event) : false;"
              ></p-dropdown>
          </div>
        </div>
        <div class="service-form-row col-4">
          <div class="label">
              <label>
                  <img src="assets/images/common/job-opt-name.png" alt="Option Valuee" class="icons-size mr-2 new-request-icon" />
                  <span class="split-col text-col"> Option Value</span>
              </label>
          </div>
          <div class="field">
            <div *ngIf="optionLoading" class="cust-loader svcm-loader">
              <img src="assets/images/landing-page/loading-more.svg" alt="Loader" />
            </div>
            <p-dropdown [placeholder]="'Select'"[options]="jobOptionValueLists" formControlName="optionValueName"
              class="input-with-icon-inside-select" optionLabel="name" optionValue="id"></p-dropdown>
          </div>
        </div>
        <div class="service-form-row col-4">
          <div class="label">
              <label>
                  <img src="assets\images\inspection-home/notes.png" alt="Job Code" class="icons-size mr-2 new-request-icon" />
                  <span class="split-col text-col">Job Code</span>
              </label>
          </div>
          <div class="field">
              <input type="text" pInputText class="input-bg map-input" formControlName="jobcode" [readonly]="isAvailable != 1" 
              [ngClass]="{ 'is-invalid': jobExist, 'is-readonly-style': isAvailable != 1 }" placeholder="Enter job code" (input)="jobCodeCheck($event.target.value);" maxlength="10" />
              <div *ngIf="jobExist" class="invalid-feedback">
                  <div id="valid-error" class="field-err" *ngIf="jobExist">{{existError}}</div>
              </div>
          </div>
        </div>
      </div>
      <div class="row service-form-fields job-form-fields col-12">
        <div class="service-form-row col-12">
          <div class="label">
              <label>
                  <img src="assets/images/repair-order/job-title.png" alt="Title" class="mr-2 new-request-icon" />
                  <span style="color: #9b9a9a;">Title</span>
                  <span class="split-col req-col">Required</span>
              </label>
          </div>
          <div class="field">
            <input class="inputbox" formControlName="jobtitle" (input)="oninputChange($event,'title')" matInput placeholder="Enter job title"
              [ngClass]="{ 'is-invalid': jobFormSubmit && jf.jobtitle.errors }" maxlength="100" />
              
            <div *ngIf="jobFormSubmit && jf.jobtitle.errors" class="invalid-feedback">
                <div id="valid-error" class="field-err" *ngIf="jf.jobtitle.errors.required">Job title is required</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row service-form-fields job-form-fields col-12">
        <div class="service-form-row col-12">
          <div class="label">
              <label>
                  <img src="assets/images/repair-order/job-desc.png" alt="Title" class="mr-2 new-request-icon" />
                  <span style="color: #9b9a9a;">Description</span>
              </label>
          </div>
          <div class="field">
            <textarea class="inputbox setDescHt mjob-desc" formControlName="jobdescription" matInput placeholder="Enter description" maxlength="500"></textarea>
          </div>
        </div>
      </div>
      <div class="row service-form-fields job-form-fields col-12">
        <div class="service-form-row col-3">
          <div class="label">
              <label>
                <img src="assets/images/common/job-dollar-icon.png" alt="Price" class="icons-size mr-2 new-request-icon" />
                <span class="split-col text-col">Price</span>
              </label>
          </div>
          <div class="field">
            <div class="p-inputgroup iborder">
              <span class="input-prefix" [ngClass]="{'active': jobForm?.value?.price?.length > 0}">$</span>
              <input type="text" pInputText class="input-bg prefix-input" formControlName="price" (keypress)="isNumberKey($event,jobForm?.value?.price,'price')"
                (change)="onFieldChange($event, 'price')" (keydown.enter)="onFieldChange($event, 'price')" pInputText placeholder="Enter price" maxlength="8" />
            </div>
          </div>
        </div>
        <div class="service-form-row col-3">
          <div class="label">
              <label>
                  <img src="assets/images/common/job-discount-icon.png" alt="Discount" class="icons-size mr-2 new-request-icon" />
                  <span class="split-col text-col">Discount</span>
              </label>
          </div>
          <div class="field">
            <div class="p-inputgroup iborder" (click)="focusDiscount()" [ngClass]="{ 'is-invalid': discountValueErrorFlag }">
              <input #discountField id="discountField" type="text" class="input-bg suffix-input" formControlName="discount" (keypress)="isNumberKey($event, jobForm?.value?.discount, 'discountPrice')" (keydown.enter)="onFieldChange($event, 'discountPrice');"
              (blur)="onFieldChange($event, 'discountPrice')" pInputText placeholder="Enter discount" [ngClass]="{ 'is-invalid': discountValueErrorFlag }" maxlength="6" (focus)="foucsInput('focus', 'discountPrice')" (focusout)="foucsInput('focus-out', 'discountPrice')" />
              <span *ngIf="!discountFocus" class="input-suffix" [ngClass]="{'active': jobForm?.value?.discount?.length > 0}">%</span>
            </div>
            <div *ngIf="discountValueErrorFlag" class="invalid-feedback discount-invalid">
              <div id="valid-error" class="field-err">{{discountValueError}}</div>
            </div>
          </div>
        </div>
        <div class="service-form-row col-2">
          <div class="label">
              <label>
                  <img src="assets/images/common/job-dollar-icon.png" alt="Cost" class="icons-size mr-2 new-request-icon" />
                  <span class="split-col text-col">Cost</span>
              </label>
          </div>
          <div class="field">
            <div class="p-inputgroup iborder bg-input-gray">
              <span class="input-prefix" [ngClass]="{'active': jobForm?.value?.cost?.length > 0}">$</span>
              <input type="text" pInputText class="input-bg prefix-input" formControlName="cost"
              placeholder="" maxlength="8" [readonly]="true" />
            </div>
          </div>
        </div>
        <div class="service-form-row col-2">
          <div class="label">
              <label>
                  <img src="assets/images/common/job-clock-icon.png" alt="Job Duration" class="icons-size mr-2 new-request-icon" />
                  <span class="split-col text-col">Job Duration</span>
              </label>
          </div>
          <div class="field">
              <p-dropdown [placeholder]="'Select'" [options]="jobDurationOptions" formControlName="jobDuration"
                class="input-with-icon-inside-select"></p-dropdown>
          </div>
        </div>
        <div class="service-form-row col-2">
          <div class="label">
              <label>
                  <img src="assets/images/common/job-qty-icon.png" alt="Quantity" class="icons-size mr-2 new-request-icon" />
                  <span class="split-col text-col">Quantity</span>
              </label>
          </div>
          <div class="field">
            <input type="text" pInputText class="input-bg map-input" formControlName="qty" (keypress)="isNumberKey($event, jobForm?.value?.qty, 'qty')"
               pInputText placeholder="Enter quantity" maxlength="5" />
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>